import React, {useState} from 'react'
import {Button, Dimmer, Form, Header, Icon, Loader, Message} from "semantic-ui-react";
import SimpleReactValidator from "simple-react-validator";

const Password = (props) => {
    const [password, setPassword] = useState();
    const [confirmPassword, setConfirmPassword] = useState();
    const [errorString, setError] = useState();
    const [passwordError, setPasswordError] = useState(false);
    const [confirmError, setConfirmError] = useState(false);
    const [loading, setLoading] = useState(false);

    const validator = new SimpleReactValidator();

    const submitForm = (e) => {

        let hasErrors = false;
        setError();
        setPasswordError(false);
        setConfirmError(false);

        if (!validator.check(password, 'required|min:8'))
        {
            setPasswordError(true);
            hasErrors = true;
            setError("Your password must be at least 8 characters long.")
        }

        if (password !== confirmPassword)
        {
            setConfirmError(true);
            hasErrors = true;
            setError("The password in the confirmation field does not match.")
        }

        if (!hasErrors)
        {
            setLoading(true);
            props.dataManager.submit(props.jwt, props.croppedPhoto, password)
                .then(response => {
                    setLoading(false);
                    if (typeof response.data.success !== "undefined") {
                        if (response.data.success == 0) {
                            setError(response.data.errorMessage);
                        } else {
                            props.setStep("complete");
                        }
                    }
                    else
                    {
                        setError(response.data);
                        setLoading(false);
                    }
                });
        }
        else
        {
            // setError is already being called separately for each case above.
        }

    }

    return (
        <div>
            <Dimmer active={loading} inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>

            <Header as='h2' style={{marginTop: 0}}>Password Selection</Header>
            <div><p>It's now time to select a password that you will use to access the ADP.  <strong>You should not share this password with anyone under any circumstance,
                as it is what uniquely identifies you in the system.</strong></p>

                <p>Please note the following important technical requirements:</p>
                <ul>
                    <li>Passwords must contain at least <strong>8 characters</strong>.</li>
                    <li>Passwords must NOT use common words or frequently-leaked passwords</li>
                    <li>Passwords must NOT contain a portion of your name or email address</li>
                </ul>
            </div>

            { (typeof errorString !== "undefined") &&
            <Message error icon>
                <Icon name='exclamation' />
                <Message.Content>
                    <Message.Header>An error occurred</Message.Header>
                    {errorString}
                </Message.Content>
            </Message>
            }

            <Form size='large' style={{marginTop: '2em'}} onSubmit={submitForm}>
                <Form.Field label="Choose your password:"  error={passwordError} type="password" control="input" value={password} onChange={(e) => setPassword(e.target.value)} required />
                <Form.Field label="Confirm your new password:"  error={confirmError} type="password" control="input" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
                <Button type='submit'>Complete Registration</Button>
            </Form>
        </div>
    )
}

export default Password;